module.exports = __webpack_public_path__ + "static/oop_class_object-c5596c75b95e77b9df8586288f8a0e13.png";